// extracted by mini-css-extract-plugin
export default {"fileUploadSection":"AddDocumentModal_fileUploadSection__EonFF","dropzone":"AddDocumentModal_dropzone__TWxPt","uploadButton":"AddDocumentModal_uploadButton__VT2Qf"};